import { combineReducers } from 'redux';

import createReducer from '../../services/create-reducer';
import map from './reducers/map';
import { SET_VIEWED_MEMBER, SET_CURRENT_MEMBER, SET_VIEWED_MEMBER_LOADING } from './actions';

const viewedMemberId = createReducer(null, {
  [SET_VIEWED_MEMBER]: (a) => a.payload.uid,
});

const currentMemberId = createReducer(null, {
  [SET_CURRENT_MEMBER]: (a) => a.payload.uid,
});

const viewedMemberLoading = createReducer(false, {
  [SET_VIEWED_MEMBER_LOADING]: (a) => a.payload,
});

export default combineReducers({
  map,
  viewedMemberId,
  currentMemberId,
  viewedMemberLoading,
});
